import React, { useMemo } from "react";
import { EditorPopup } from "../EditorPopup/EditorPopup";
export const EditorCursorPopup = (props) => {
    const { view, from, to, ...rest } = props;
    const virtualReference = useMemo(() => {
        var _a;
        if (!view) {
            return;
        }
        if (!((_a = view.state.doc.content) === null || _a === void 0 ? void 0 : _a.size) || view.state.doc.content.size === 0) {
            return {
                getBoundingClientRect() {
                    return {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        toJSON: () => null,
                    };
                },
                contextElement: view.dom,
            };
        }
        return {
            getBoundingClientRect() {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                // Fallback to 0 if `view.state.doc?.content?.size` is undefined
                const maxPos = (_c = (_b = (_a = view.state.doc) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0 ? _c : 0;
                // Ensure `from` and `to` are valid numbers, defaulting to 0 if undefined
                const safeFrom = Math.min(from !== null && from !== void 0 ? from : 0, maxPos);
                const safeTo = Math.min(to !== null && to !== void 0 ? to : 0, maxPos);
                // Fallback to { left: 0, top: 0, right: 0, bottom: 0 } if coords are invalid
                const fromPos = safeFrom >= 0
                    ? view.coordsAtPos(safeFrom)
                    : { left: 0, top: 0, right: 0, bottom: 0 };
                const toPos = safeTo >= 0
                    ? view.coordsAtPos(safeTo)
                    : { left: 0, top: 0, right: 0, bottom: 0 };
                // Ensure all calculated values are safe
                return {
                    left: (_d = fromPos === null || fromPos === void 0 ? void 0 : fromPos.left) !== null && _d !== void 0 ? _d : 0,
                    top: (_e = fromPos === null || fromPos === void 0 ? void 0 : fromPos.top) !== null && _e !== void 0 ? _e : 0,
                    right: Math.max((_f = fromPos === null || fromPos === void 0 ? void 0 : fromPos.right) !== null && _f !== void 0 ? _f : 0, (_g = toPos === null || toPos === void 0 ? void 0 : toPos.right) !== null && _g !== void 0 ? _g : 0),
                    bottom: Math.max((_h = fromPos === null || fromPos === void 0 ? void 0 : fromPos.bottom) !== null && _h !== void 0 ? _h : 0, (_j = toPos === null || toPos === void 0 ? void 0 : toPos.bottom) !== null && _j !== void 0 ? _j : 0),
                    width: Math.max(0, ((_k = toPos === null || toPos === void 0 ? void 0 : toPos.right) !== null && _k !== void 0 ? _k : 0) - ((_l = fromPos === null || fromPos === void 0 ? void 0 : fromPos.left) !== null && _l !== void 0 ? _l : 0)),
                    height: Math.max(0, ((_m = toPos === null || toPos === void 0 ? void 0 : toPos.bottom) !== null && _m !== void 0 ? _m : 0) - ((_o = fromPos === null || fromPos === void 0 ? void 0 : fromPos.top) !== null && _o !== void 0 ? _o : 0)),
                    x: (_p = fromPos === null || fromPos === void 0 ? void 0 : fromPos.left) !== null && _p !== void 0 ? _p : 0,
                    y: (_q = fromPos === null || fromPos === void 0 ? void 0 : fromPos.top) !== null && _q !== void 0 ? _q : 0,
                    toJSON: () => null,
                };
            },
            contextElement: view.dom,
        };
    }, [view, from, to]);
    if (!view) {
        return null;
    }
    return (React.createElement(EditorPopup, { referenceElement: virtualReference, view: view, ...rest }));
};
